import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

export const getKsefState = (state: RootState) => state.common.ksef

export const getConnection = createSelector(
  getKsefState,
  state => state.connection
)

export const getAdded = createSelector(getKsefState, state => state.added)

export const getKsefInvoices = createSelector(
  getKsefState,
  state => state.ksefInvoices
)
export const getKsefImports = createSelector(
  getKsefState,
  state => state.imports
)

export const getSummary = createSelector(getKsefState, state => state.summary)

export const getDownloadReport = createSelector(
  getKsefState,
  state => state.downloadReport
)
